// Draft store for the Add Donor form (see helpers/formDraft). One per user.
import { anyFilled, createDraftStore } from 'helpers/formDraft';

export const donorDraftStore = createDraftStore({
  prefix: 'donor-draft',
  hasContent: values =>
    anyFilled([
      values?.firstName,
      values?.lastName,
      values?.emails?.[0]?.email,
      values?.phoneNumbers?.[0]?.phoneNumber,
      values?.addresses?.[0]?.addressLine1,
      values?.addresses?.[0]?.postcode,
      values?.comment,
      values?.username,
      values?.website,
      values?.job_title,
      values?.partner_name
    ])
});
